export default __webpack_public_path__ + "static/media/icon01.daf6226e.svg";